module.exports = __webpack_public_path__ + "static/media/stamos-theme-finale.5eadce38.mp3";